export default "__VITE_ASSET__Czx17xPN__"